import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DeezerLoginPromptService } from './deezer-login-prompt.service';
import { PlayerModeService } from './player-mode.service';

/** Tiny switch between Deezer's full-song player and 30-second previews. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-player-mode-toggle',
  template: `
    <span class="toggle">
      Player:
      @if (player.mode() === 'deezer') {
      <strong>Deezer (full songs)</strong> &middot;
      <button type="button" (click)="player.setMode('preview')">use 30s previews</button> &middot;
      <button type="button" (click)="login.openDeezerLogin()">log in to Deezer</button>
      } @else {
      <strong>30s previews</strong> &middot;
      <button type="button" (click)="player.setMode('deezer')">use Deezer player</button>
      }
    </span>
  `,
  styles: [`
    .toggle { font-size: 0.8rem; color: #666; }
    button { font: inherit; border: none; background: none; color: #673ab7; cursor: pointer; padding: 0; text-decoration: underline; }
  `]
})
export class PlayerModeToggleComponent {
  protected player = inject(PlayerModeService);
  protected login = inject(DeezerLoginPromptService);
}
